import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RtTripCriteriaDialogData {
    title?: string;
    customerNumber?: string;
    destinationCity?: string;
    destinationState?: string;
    originCity?: string;
    originState?: string;
    tripId?: number;
    returnCity?: string;
    returnState?: string;
    showDestinationCriteria?: boolean;
    showOriginCriteria?: boolean;
}

export interface RtTripCriteriaDialogResult {
    action: 'save' | 'cancel';
    data?: any;
}

@Component({
    selector: 'rt-trip-criteria-dialog',
    templateUrl: './rt-trip-criteria-dialog.component.html',
    styleUrls: ['./rt-trip-criteria-dialog.component.scss'],
})
export class RtTripCriteriaDialogComponent implements OnInit {
    title: string;
    customerNumber: string;
    destinationCity: string;
    destinationState: string;
    originCity: string;
    originState: string;
    tripId: number;
    returnCity: string;
    returnState: string;
    showDestinationCriteria: boolean = true;
    showOriginCriteria: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<RtTripCriteriaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RtTripCriteriaDialogData,
    ) {
        this.title = data?.title || 'Trip Criteria';
        this.customerNumber = data?.customerNumber || '';
        this.destinationCity = data?.destinationCity || '';
        this.destinationState = data?.destinationState || '';
        this.originCity = data?.originCity || '';
        this.originState = data?.originState || '';
        this.tripId = data?.tripId || 0;
        this.returnCity = data?.returnCity || '';
        this.returnState = data?.returnState || '';
        this.showDestinationCriteria = data?.showDestinationCriteria ?? true;
        this.showOriginCriteria = data?.showOriginCriteria ?? true;
    }

    ngOnInit(): void {
        // Initialize any additional data if needed
    }

    onCriteriaChanged(): void {
        // Handle criteria changes if needed
        console.log('Criteria changed in dialog');
    }

    onSave(): void {
        const result: RtTripCriteriaDialogResult = {
            action: 'save',
            data: {
                customerNumber: this.customerNumber,
                destinationCity: this.destinationCity,
                destinationState: this.destinationState,
                originCity: this.originCity,
                originState: this.originState,
                tripId: this.tripId,
                returnCity: this.returnCity,
                returnState: this.returnState,
            },
        };

        this.dialogRef.close(result);
    }

    onCancel(): void {
        const result: RtTripCriteriaDialogResult = {
            action: 'cancel',
        };

        this.dialogRef.close(result);
    }
}
